import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const getCustomerPackageOffer = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL + '/store/api/secure/v1/brand/' + brandId + '/subscriber',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getAllCustomerPackageOffer = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL + '/store/api/secure/v1/brand/' + brandId + '/subscriber-details',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getCustomerPackageOfferLog = (brandId, storeId, subscriberId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store/' +
      storeId +
      '/subscriber/' +
      subscriberId +
      '/log',
    headers: getHeaders(),
  });
};

export const postCustomerPackageOfferLog = (brandId, storeId, subscriberId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store/' +
      storeId +
      '/subscriber/' +
      subscriberId +
      '/log',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const postCustomerPackageOfferLogSubscriberLedger = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/subscriber-ledger/',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addCustomerPackageOffer = (brandId, storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store/' +
      storeId +
      '/subscriber',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const putCustomerPackageOffer = (brandId, storeId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store/' +
      storeId +
      '/subscriber',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const postCustomerPackageOfferSubscriptionRollback = (brandId, storeId, subscriberId ,data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store/' +
      storeId +
      '/subscriber/' + subscriberId + '/rollback-subscribe',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const putCustomerPackageOfferReSubscribe = (brandId, storeId, subscriberId ,data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store/' +
      storeId +
      '/subscriber/' + subscriberId + '/re-subscribe',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getCustomerPackageOfferSubscriptionLog = (brandId, storeId, subscriberId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store/' +
      storeId +
      '/subscriber/' +
      subscriberId +
      '/subscription-log',
    headers: getHeaders(),
  });
};

export const paginationCustomerPackageOfferSubscriptionLog = (brandId, storeId, subscriberId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store/' +
      storeId +
      '/subscriber/' +
      subscriberId +
      '/subscription-log',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const convertCustomerSubscriptionBalanceToWallet = (brandId, storeId, subscriberId, data) => {
  return axios({
    method: 'put',
    url:
    STORE_BASE_URL +
    '/store/api/secure/v1/brand/' +
    brandId +
    '/store/' +
    storeId +
    '/subscriber/' +
    subscriberId +
    '/subscription-balance-to-wallet',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getCustomerCheckLeftSubscriptionBalance = (brandId, storeId, subscriberId, activeAlso) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store/' +
      storeId +
      '/subscriber/' +
      subscriberId +
      '/check-left-subscription-balance/' + activeAlso,
    headers: getHeaders(),
  });
};


// Subscription Qr Payment

export const GenerateSubscriptionPaymentQr = (brandId, storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store/' +
      storeId +
      '/generate-subscription-payment-qr',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const SubscriptionPaymentQr = (brandId, storeId, subscriptionPaymentQrId) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store/' +
      storeId +
      '/subscription-payment-qr/' + subscriptionPaymentQrId,
    headers: getHeaders(),
  });
};

// 

export const GenerateSubscriptionPaymentLink = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/subscription-payment-link',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const ReGenerateSubscriptionPaymentLink = (id) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/resend-payment-link/' + id ,
    headers: getHeaders(),
  });
};